import { useCallback } from 'react';

import { Tasks } from '@air/api';

import { useCurrentWorkspace } from '~/providers/CurrentWorkspaceProvider';
import { type AssetRestorationTask, type GetBaseMetadata } from '~/store/tasks/types';
import { useCreateTask } from '~/utils/taskUtils/useCreateTask';

export type CreateAssetRestorationTaskParams = GetBaseMetadata<AssetRestorationTask>;

export type NewParentLocation = CreateAssetRestorationTaskParams['parent'];

export const useAssetRestorationTask = () => {
  const { currentWorkspace } = useCurrentWorkspace();
  const { createTask } = useCreateTask();

  const createAssetRestorationTask = useCallback(
    ({ assets, parent }: CreateAssetRestorationTaskParams) => {
      const workspaceId = currentWorkspace?.id;
      if (!workspaceId) {
        throw new Error('No workspace id');
      }
      return createTask({
        task: {
          metadata: { assets, parent },
          type: 'AssetRestoration',
        },
        createTask: () =>
          Tasks.createTask({
            workspaceId,
            task: {
              type: 'ContentRestorer',
              args: { assetIds: assets.map(({ id }) => id), parent: parent === 'root' ? null : parent },
            },
          }),
      });
    },
    [createTask, currentWorkspace?.id],
  );

  return { createAssetRestorationTask };
};
